module.exports = __webpack_public_path__ + "media/images/icons/benefits_exclusive_dates-beadf2dfdeaa218fc73829132f0dd86f.svg";